import configFile from '@/../app-config.js'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { languagePack } from '@/../locales/fr/index.js'
import Formatter, { dateTimeFormats, numberFormats } from '@/utils/formatter'

Vue.use(VueI18n)

export const defaultLocale = configFile[process.env.APP_ID].params.defaultLocale

const locales = {
  'fr-FR': languagePack
}
const formatter = new Formatter({ locale: defaultLocale })

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  formatter,
  messages: locales,
  dateTimeFormats,
  numberFormats
})
